import React from 'react';
import PropTypes from 'prop-types';
import './visually-hidden-legend.scss';

// A <legend> that's visually hidden but still readable by screen readers - for a
// <fieldset> whose group already has a visible heading/title elsewhere on the page,
// so a second, visible legend would just duplicate it.
const VisuallyHiddenLegend = ({ children }) => (
  <legend styleName="visually-hidden">{children}</legend>
);

VisuallyHiddenLegend.propTypes = {
  children: PropTypes.node
};

export default VisuallyHiddenLegend;
